import { render } from "./SeatClass.vue?vue&type=template&id=3c0a0549&scoped=true"
import script from "./SeatClass.vue?vue&type=script&lang=js"
export * from "./SeatClass.vue?vue&type=script&lang=js"

import "./SeatClass.vue?vue&type=style&index=0&id=3c0a0549&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0a0549"]])

export default __exports__